import type { AdminCustomerCart } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";

export type CartItem = AdminCustomerCart["items"][number];

export class CustomerCartsState {
  /** `?cart=<id>`: the cart to bring into view, from a customer's Checkout. */
  constructor(readonly focusCartId: string | null = null) {}

  /** Null until the shell has resolved the shop. */
  readonly shopId = new Rx<string | null>(null);
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly carts = new RxList<AdminCustomerCart>();
  readonly busyItemId = new Rx<string | null>(null);
  readonly busyCartId = new Rx<string | null>(null);
  readonly confirmDeleteId = new Rx<string | null>(null);
  readonly deleteError = new Rx<{ id: string; message: string } | null>(null);
  readonly actionError = new Rx<string | null>(null);
  /** The cart the terminal modal is open for. */
  readonly payingCart = new Rx<AdminCustomerCart | null>(null);
  readonly openCarts = new Rx(0);
}

export abstract class CustomerCartsActions {
  abstract reload(): void;
  abstract toggleInclude(cart: AdminCustomerCart, item: CartItem): Promise<void>;
  abstract removeItem(cart: AdminCustomerCart, item: CartItem): Promise<void>;
  abstract promptDelete(cart: AdminCustomerCart): void;
  abstract cancelDelete(): void;
  abstract confirmDelete(cart: AdminCustomerCart): Promise<void>;
  abstract takePayment(cart: AdminCustomerCart): void;
  abstract showQr(): void;
}
